import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
// import "./programType.Reponsive.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};

export default function SalesOrderList() {
  const { adminDetails } = PagesIndex.useSelector(
    (state) => state.AdminReducer
  );

  const formRef = useRef();
  const formRefFilter = useRef();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [modalData, setModalData] = useState({});
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const [blockButtonSpinner, setBlockButtonSpinner] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  // add user modal
  const [openDelete, setOpenDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteButtonSpinner, setDeleteButtonSpinner] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [prevBookingsData, setPrevBookingsData] = useState([]);
  const [openLogModal, setOpenLogModal] = useState(false);
  const [activityLog, setActivityLog] = useState([]);
  const [activityLoading, setActivityLoading] = useState(true);
  const [openCalenderStart, setOpenCalenderStart] = useState(false);
  const [openCalenderEnd, setOpenCalenderEnd] = useState(false);
  const [openMessage, setOpenMessage] = useState(false);
  const handleOpenMessage = () => setOpenMessage(true);
  const handleCloseMessage = () => {
    setSelectedValue("");
    setOpenMessage(false);
    formRef.current.resetForm();
  };

  const open = Boolean(anchorEl);
  const handleClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    setId(data?._id);
    setModalData(data);
  };
  const handleMenuItemClick = (value) => {
    setSelectedValue(value);
    handleClose();
  };
  const handleClose = () => {
    setAnchorEl(null);
    formRef.current.resetForm();
  };

  // add message modal
  const [openView, setOpenView] = useState(false);
  const handleOpenView = (data, id) => {
    setOpenView(true);
    setModalData(data);
    setId(id);
  };
  const handleCloseView = () => {
    setOpenView(false);
    formRef.current.resetForm();
  };

  const initialValues = {
    reason: id && modalData?.status == "Reject" ? modalData?.reason : "",
  };
  const initialValuesFilter = {
    startDate: null,
    endDate: null,
  };
  const handleOpenDelete = (id) => {
    setOpenDelete(true);
    setId(id);
  };
  const handleCloseDelete = () => {
    setId("");
    setOpenDelete(false);
  };
  const handleGetSalesOrder = () => {
    const urlEncoded = new URLSearchParams();
    setLoading(true);
    urlEncoded.append("search", searchValue);
    if (formRefFilter?.current?.values?.isSubmit == true) {
      if (formRefFilter?.current?.values?.startDate) {
        urlEncoded.append(
          "from",
          PagesIndex.moment(
            new Date(formRefFilter?.current?.values?.startDate)
          ).format("YYYY-MM-DD")
        );
      }
      if (formRefFilter?.current?.values?.endDate) {
        urlEncoded.append(
          "to",
          PagesIndex.moment(
            new Date(formRefFilter?.current?.values?.endDate)
          ).format("YYYY-MM-DD")
        );
      }
    }
    urlEncoded.append("pageNumber", currentPage);
    urlEncoded.append("pageSize", 10);
    PagesIndex.apiPostHandler(
      PagesIndex.Api.GET_ALL_SALES_ORDERS,
      urlEncoded
    ).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setData(res?.data);
        setFilteredData(res?.data?.paginatedResults);
      }
    });
  };
  const handleGetPreviousBookings = () => {
    setLoading(true);
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_BOOKING + "/" + id).then(
      (res) => {
        setLoading(false);
        if (res.status === 200) {
          setPrevBookingsData(res.data?.findSalesOrder);
        }
      }
    );
  };
  useEffect(() => {
    handleGetSalesOrder();
  }, [searchValue, currentPage]);

  useEffect(() => {
    id && handleGetPreviousBookings();
  }, [id]);

  const handleDeleteSalesOrder = () => {
    setDeleteButtonSpinner(true);
    const urlEncoded = new URLSearchParams();
    urlEncoded.append("id", id);
    PagesIndex.apiPostHandler(
      PagesIndex.Api.DELETE_SALES_ORDER,
      urlEncoded
    ).then((res) => {
      setDeleteButtonSpinner(false);
      if (res.status === 200) {
        handleCloseDelete();
        handleGetSalesOrder();
        PagesIndex.toasterSuccess(res?.message);
      } else {
        PagesIndex.toasterError(res?.message);
      }
    });
  };

  const requestSearch = (e) => {
    setSearchValue(e.target.value);
    // let filteredData = data.filter(
    //   (data) =>
    //     data?.client?.firstName
    //       ?.toLowerCase()
    //       .includes(e?.target?.value?.trim()?.toLowerCase()) ||
    //     PagesIndex.moment(new Date(data?.updatedAt))
    //       .format("YYYY-MM-DD")
    //       .includes(e?.target?.value?.trim()?.toLowerCase()) ||
    //     data?.orderNo
    //       ?.toLowerCase()
    //       .includes(e?.target?.value?.trim()?.toLowerCase()) ||
    //     data?.createdBy?.name
    //       ?.toLowerCase()
    //       .includes(e?.target?.value?.trim()?.toLowerCase()) ||
    //     data?.totalAmount
    //       ?.toLowerCase()
    //       .includes(e?.target?.value?.trim()?.toLowerCase())
    // );
    setCurrentPage(1);
    // setFilteredData(filteredData);
  };

  const renderTableRows = () => {
    return filteredData
      ?.slice((currentPage - 1) * 10, (currentPage - 1) * 10 + 10)
      ?.map((data) => {
        return (
          <Index.TableRow
            sx={{
              "&:last-child td, &:last-child th": {
                border: 0,
              },
            }}
            key={data?._id}
          >
            <Index.TableCell component="td" variant="td" className="table-td">
              <Index.Typography className="admin-table-data-text">
                <span className="news-id-text">{data?.orderNo}</span>
              </Index.Typography>
            </Index.TableCell>
            <Index.TableCell
              component="td"
              variant="td"
              scope="row"
              className="table-td"
            >
              <Index.Typography className="admin-table-data-text news-id-text">
                {data?.client?.compName || "-"}
              </Index.Typography>

              <Index.Typography className="admin-table-data-text">
                {data?.client?.firstName || "-"}
              </Index.Typography>
            </Index.TableCell>

            <Index.TableCell component="td" variant="td" className="table-td">
              <Index.Typography className="admin-table-data-text">
                {data?.campaignName}
              </Index.Typography>
            </Index.TableCell>

            <Index.TableCell component="td" variant="td" className="table-td">
              <Index.Typography className="admin-table-data-text">
                {parseFloat(data?.totalAmount)?.toLocaleString("en-Us") || "-"}
              </Index.Typography>
            </Index.TableCell>

            <Index.TableCell component="td" variant="td" className="table-td">
              <Index.Typography className="admin-table-data-text">
                {data?.updatedAt || data?.createdBy?.name
                  ? data?.createdBy?.name +
                    "-" +
                    PagesIndex.moment(new Date(data?.updatedAt)).format(
                      "DD/MM/YYYY hh:mm A"
                    )
                  : "-"}
              </Index.Typography>
            </Index.TableCell>

            <Index.TableCell
              component="td"
              variant="td"
              align="right"
              className="table-td"
            >
              <Index.Box className="admin-table-data-btn-flex ">
                {adminDetails?.roleId?.permissions?.includes(
                  "sales_order_edit"
                ) &&
                  adminDetails?._id !== data?.approvalId?._id && (
                    <Index.Tooltip
                      title="Edit"
                      arrow
                      placement="bottom"
                      className="admin-tooltip"
                    >
                      <Index.Button
                        className="admin-table-data-btn"
                        onClick={() => {
                          navigate(`/admin/add-sales-order/${data?._id}`, {
                            state: {
                              orderList: data,
                            },
                          });
                        }}
                      >
                        <img
                          src={PagesIndex.Svg.blueedit}
                          className="admin-icon"
                          alt="Edit"
                        ></img>
                      </Index.Button>
                    </Index.Tooltip>
                  )}

                <Index.Tooltip
                  title="View"
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Button
                    className="admin-table-data-btn"
                    onClick={() =>
                      navigate(`/admin/view-sales-order/${data?._id}`)
                    }
                    // onClick={() => handleOpenView(data, data?._id)}
                  >
                    <img
                      src={PagesIndex.Svg.yelloweye}
                      className="admin-icon"
                      alt="View"
                    />
                  </Index.Button>
                </Index.Tooltip>

                <Index.Tooltip
                  title="View Bookings"
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Button
                    className="admin-table-data-btn"
                    onClick={() => {
                      navigate(`/admin/sales-sub-order-list/${data?._id}`);
                    }}
                  >
                    <img
                      src={PagesIndex.Svg.viewbookingIcon}
                      className="admin-icon"
                      alt="View Booking"
                    />
                  </Index.Button>
                </Index.Tooltip>
                {adminDetails?.roleId?.permissions?.includes(
                  "sales_order_log"
                ) && (
                  <Index.Tooltip
                    title="Log"
                    arrow
                    placement="bottom"
                    className="admin-tooltip"
                  >
                    <Index.Button
                      className="admin-table-data-btn"
                      onClick={() => handleOpenLogModal(data?._id)}
                    >
                      <img
                        src={PagesIndex.Svg.logicon}
                        className="admin-icon"
                        alt="Log"
                      ></img>
                    </Index.Button>
                  </Index.Tooltip>
                )}
                {adminDetails?.roleId?.permissions?.includes(
                  "sales_order_add"
                ) && (
                  <Index.Tooltip
                    title="Add Booking"
                    arrow
                    placement="bottom"
                    className="admin-tooltip"
                  >
                    <Index.Button
                      className="admin-table-data-btn"
                      onClick={() => {
                        navigate(`/admin/add-sales-sub-order/${data?._id}`, {
                          state: {
                            orderList: data,
                          },
                        });
                      }}
                    >
                      <img
                        src={PagesIndex.Svg.darkplus}
                        className="admin-icon"
                        alt="Plus"
                      ></img>
                    </Index.Button>
                  </Index.Tooltip>
                )}

                {adminDetails?.roleId?.permissions?.includes(
                  "sales_order_delete"
                ) && (
                  <Index.Tooltip
                    title="Delete"
                    arrow
                    placement="bottom"
                    className="admin-tooltip"
                  >
                    <Index.Button
                      className="admin-table-data-btn"
                      onClick={() => handleOpenDelete(data?._id)}
                      // onClick={() => handleOpenMessage(data?._id)}
                    >
                      <img
                        src={PagesIndex.Svg.trash}
                        className="admin-icon"
                        alt="Delete"
                      ></img>
                    </Index.Button>
                  </Index.Tooltip>
                )}
                {adminDetails?._id == data?.approvalId?._id &&
                  data?.status == "Pending" && (
                    <Index.Tooltip
                      title={anchorEl == null ? "Menu" : ""}
                      arrow
                      placement="bottom"
                      className="admin-tooltip"
                    >
                      <Index.Box className="action-menu-main">
                        <Index.Button
                          id="basic-button"
                          className="admin-table-data-btn"
                          aria-controls={open ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          onClick={(e) => handleClick(e, data)}
                        >
                          <img
                            src={PagesIndex.Svg.DotsIcon}
                            className="admin-icon"
                            alt="Delete"
                          ></img>
                        </Index.Button>
                        <Index.Menu
                          className="action-menu"
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          <Index.MenuItem
                            className="admin-drop-header-menuitem"
                            onClick={() => handleMenuItemClick("Approve")}
                          >
                            Approve
                          </Index.MenuItem>
                          {/* <Index.MenuItem className="admin-drop-header-menuitem" onClick={() => handleMenuItemClick('Pending')}>Pending</Index.MenuItem> */}
                          <Index.MenuItem
                            className="admin-drop-header-menuitem"
                            onClick={() => handleMenuItemClick("Reject")}
                          >
                            Reject
                          </Index.MenuItem>
                        </Index.Menu>
                      </Index.Box>
                    </Index.Tooltip>
                  )}
              </Index.Box>
            </Index.TableCell>
          </Index.TableRow>
        );
      });
  };
  const renderContent = () => {
    if (filteredData?.length) {
      return renderTableRows();
    } else {
      return <PagesIndex.DataNotFound />;
    }
  };
  const handleOpenLogModal = (id) => {
    setOpenLogModal(true);
    setActivityLoading(true);
    PagesIndex.apiGetHandler(
      PagesIndex.Api.GET_SALES_ORDER_ACTIVITY_LOG + "/" + id
    ).then((res) => {
      setActivityLoading(false);
      if (res.status === 200) {
        setActivityLog(res.data);
      }
    });
  };
  const handleCloseLogModal = () => setOpenLogModal(false);
  const renderActivityTableRows = () => {
    return activityLog.reverse().map((data) => {
      return (
        <Index.TableRow
          sx={{
            "&:last-child td, &:last-child th": {
              border: 0,
            },
          }}
          key={data?._id}
        >
          <Index.TableCell
            component="td"
            variant="td"
            scope="row"
            className="table-td"
          >
            <Index.Typography className="admin-table-data-text">
              <Index.Tooltip
                title={data?.actionType}
                arrow
                placement="top"
                className="admin-tooltip"
              >
                {data?.actionType}
              </Index.Tooltip>
            </Index.Typography>
          </Index.TableCell>

          <Index.TableCell component="td" variant="td" className="table-td">
            {data?.actionBy?.name}-
            {PagesIndex.moment(data?.updatedAt).format("DD/MM/YYYY hh:mm:ss")}
          </Index.TableCell>
        </Index.TableRow>
      );
    });
  };
  const renderActivityLogContent = () => {
    return (
      <>
        {!activityLoading &&
          activityLog?.length > 0 &&
          renderActivityTableRows()}
        {!activityLoading && activityLog.length === 0 && (
          <PagesIndex.DataNotFound />
        )}
      </>
    );
  };

  const handleDownloadVideo = async (data) => {
    const a = document.createElement("a");

    a.setAttribute("download", data?.documentsName); // Replace with the desired filename for the downloaded file
    a.href = process.env.REACT_APP_IMAGE_ENDPOINT + data?.file;
    a.click();
    window.URL.revokeObjectURL(
      process.env.REACT_APP_IMAGE_ENDPOINT + data?.file
    );
  };
  const handleAddEditBlockResone = (values) => {
    setBlockButtonSpinner(true);
    const urlEncoded = new URLSearchParams();
    urlEncoded.append("id", id);
    if (values?.reason) {
      urlEncoded.append("reason", values?.reason);
      urlEncoded.append("status", "Reject");
    } else {
      urlEncoded.append("status", selectedValue);
    }
    if (values?.reason) {
    }
    PagesIndex.apiPostHandler(PagesIndex.Api.GET_SALES_STATUS, urlEncoded)
      .then((res) => {
        setBlockButtonSpinner(false);
        if (res.status === 201 || res.status === 200) {
          handleCloseMessage();
          handleGetSalesOrder();
          handleCloseView();
          PagesIndex.toasterSuccess(res?.message);
        } else {
          PagesIndex.toasterError(res?.message);
        }
      })
      .catch((err) => {
        PagesIndex.toasterError(err.response.message);
      });
    setSelectedValue("");
  };

  useEffect(() => {
    if (selectedValue) {
      if (selectedValue == "Reject") {
        handleOpenMessage();
      } else {
        handleAddEditBlockResone();
      }
    }
  }, [selectedValue]);
  const exportData = (data, fileName, type) => {
    // Create a link and download the file
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
  const generateCSV = async () => {
    let headers = [];
    headers = [
      "Order Id",
      "Company Name",
      "Client",
      "Deal name",
      "Total Amount",
      "Created Date & Time",
    ];
    let modifiedData = filteredData.map((data) => {
      let objData = [];
      objData = [
        data?.orderNo ? data?.orderNo : "-",
        data?.client?.compName
          ? data?.client?.compName?.replaceAll(",", " ")
          : "-",
        data?.client?.firstName ? data?.client?.firstName : "-",
        data?.campaignName ? data?.campaignName?.replaceAll(",", " ") : "-",
        data?.totalAmount ? parseFloat(data?.totalAmount) : "-",
        data?.createdAt || data?.createdBy?.name
          ? data?.createdBy?.name +
            "-" +
            PagesIndex.moment(new Date(data?.createdAt)).format(
              "DD/MM/YYYY hh:mm A"
            )
          : "-",
      ];

      return objData.join(",");
    });

    exportData(
      [[headers, ...modifiedData].join("\n")],
      `${PagesIndex.moment().format("DD-MM-YYYY")}_Sales-deal_list.csv`,
      "text/csv"
    );
  };
  return (
    <>
      <Index.Box className="admin-dashboard-content admin-user-list-content">
        <Index.Box className="admin-user-list-flex admin-page-title-main">
          <Index.Typography
            className="admin-page-title admin-user-list-page-title"
            component="h2"
            variant="h2"
          >
            Sales Deal List
          </Index.Typography>
          <Index.Box className="admin-userlist-btn-flex">
            <Index.Box className="admin-search-main">
              <Index.Box className="admin-search-box">
                <Index.Box className="admin-form-group">
                  <Index.TextField
                    fullWidth
                    id="fullWidth"
                    className="admin-form-control"
                    placeholder="Search"
                    value={searchValue}
                    onChange={requestSearch}
                  />
                  <img
                    src={PagesIndex.Svg.search}
                    className="admin-search-grey-img admin-icon"
                    alt="search"
                  ></img>
                </Index.Box>
              </Index.Box>
            </Index.Box>
            {adminDetails?.roleId?.permissions?.includes("sales_order_add") && (
              <Index.Box className="admin-userlist-inner-btn-flex">
                <Index.Box className="admin-adduser-btn-main btn-main-primary">
                  <Index.Button
                    className="admin-adduser-btn btn-primary"
                    onClick={() => {
                      navigate(`/admin/add-sales-order`);
                    }}
                  >
                    <img
                      src={PagesIndex.Svg.plus}
                      className="admin-plus-icon"
                      alt="plus"
                    />
                    <span>Add Deal</span>
                  </Index.Button>
                </Index.Box>
              </Index.Box>
            )}
            <Index.Box className="admin-adduser-btn-main btn-main-secondary">
              <Index.Button
                className="admin-adduser-btn btn-secondary"
                onClick={generateCSV}
              >
                <img
                  src={PagesIndex.Svg.exporticon}
                  className="admin-plus-icon"
                  alt="plus"
                />
                <span>Export CSV</span>
              </Index.Button>
            </Index.Box>
          </Index.Box>
        </Index.Box>
        <Index.Box className="filter-card common-card">
          <Index.Box className="filter-flex">
            <Index.Box className="grid-row">
              <PagesIndex.Formik
                enableReinitialize
                onSubmit={handleGetSalesOrder}
                initialValues={initialValuesFilter}
                // validationSchema={PagesIndex.advertiserFilterSchema}
                innerRef={formRefFilter}
              >
                {({ values, errors, touched, handleSubmit, setFieldValue }) => (
                  <form onSubmit={handleSubmit} noValidate="novalidate">
                    <Index.Box sx={{ width: 1 }} className="grid-main">
                      <Index.Box
                        display="grid"
                        gridTemplateColumns="repeat(12, 1fr)"
                        gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                      >
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="admin-input-box advertiser-filter-input admin-date-input-main">
                            <Index.FormHelperText className="admin-form-lable">
                              <span>From Date</span>
                            </Index.FormHelperText>
                            <Index.Box className="admin-form-group">
                              <PagesIndex.LocalizationProvider
                                dateAdapter={PagesIndex.AdapterDayjs}
                                className="date-localization-main"
                              >
                                <PagesIndex.DatePicker
                                  open={openCalenderStart}
                                  onClose={() => setOpenCalenderStart(false)}
                                  className="admin-form-control admin-date-picker-control"
                                  value={values.startDate}
                                  onChange={(date) => {
                                    setFieldValue("startDate", date);
                                    setFieldValue("endDate", null);
                                  }}
                                  slotProps={{
                                    popper: {
                                      className: "date-picker-body",
                                    },
                                    textField: {
                                      readOnly: true,
                                      onClick: () => setOpenCalenderStart(true),
                                    },
                                    inputAdornment: {
                                      onClick: () => setOpenCalenderStart(true), // This triggers on the calendar icon
                                    },
                                  }}
                                  format="DD/MM/YYYY"
                                />
                              </PagesIndex.LocalizationProvider>
                            </Index.Box>
                            <PagesIndex.FormHelperText className="admin-error-text">
                              {errors.startDate && touched.startDate
                                ? errors.startDate
                                : null}
                            </PagesIndex.FormHelperText>
                          </Index.Box>
                        </Index.Box>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="admin-input-box advertiser-filter-input admin-date-input-main">
                            <Index.FormHelperText className="admin-form-lable">
                              <span>To Date</span>
                            </Index.FormHelperText>
                            <Index.Box className="admin-form-group">
                              <PagesIndex.LocalizationProvider
                                dateAdapter={PagesIndex.AdapterDayjs}
                                className="date-localization-main"
                              >
                                <PagesIndex.DatePicker
                                  open={openCalenderEnd}
                                  onClose={() => setOpenCalenderEnd(false)}
                                  className="admin-form-control admin-date-picker-control"
                                  value={values.endDate}
                                  minDate={dayjs(values.startDate).add(
                                    0,
                                    "day"
                                  )}
                                  onChange={(date) => {
                                    setFieldValue("endDate", date);
                                  }}
                                  slotProps={{
                                    popper: {
                                      className: "date-picker-body",
                                    },
                                    textField: {
                                      readOnly: true,
                                      onClick: () => setOpenCalenderEnd(true),
                                    },
                                    inputAdornment: {
                                      onClick: () => setOpenCalenderEnd(true), // This triggers on the calendar icon
                                    },
                                  }}
                                  format="DD/MM/YYYY"
                                />
                              </PagesIndex.LocalizationProvider>
                            </Index.Box>
                            <PagesIndex.FormHelperText className="admin-error-text">
                              {errors.endDate && touched.endDate
                                ? errors.endDate
                                : null}
                            </PagesIndex.FormHelperText>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box sx={{ width: 1 }} className="grid-main">
                      <Index.Box
                        className="filter-row"
                        display="grid"
                        gridTemplateColumns="repeat(12, 1fr)"
                        gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                      >
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 12",
                            md: "span 12",
                            lg: "span 12",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="filter-btns">
                            <Index.Tooltip
                              title="Search"
                              arrow
                              placement="top"
                              className="admin-tooltip"
                            >
                              <Index.Box className="btn-main-primary admin-icons-btn-main">
                                <Index.Button
                                  className="btn-primary admin-icons-btn"
                                  type="submit"
                                  disabled={
                                    (formRefFilter?.current?.values?.endDate ||
                                      formRefFilter?.current?.values
                                        ?.startDate) == null
                                      ? true
                                      : false
                                  }
                                  onClick={() =>
                                    setFieldValue("isSubmit", true)
                                  }
                                >
                                  <img
                                    src={PagesIndex.Svg.searchwhite}
                                    className="admin-icons"
                                    alt="Save"
                                  />
                                </Index.Button>
                              </Index.Box>
                            </Index.Tooltip>
                            <Index.Tooltip
                              title="Reset"
                              arrow
                              placement="top"
                              className="admin-tooltip"
                            >
                              <Index.Box className="btn-main-primary admin-icons-btn-main">
                                <Index.Button
                                  className="btn-primary admin-icons-btn"
                                  onClick={() => {
                                    formRefFilter?.current?.resetForm();
                                    setCurrentPage(1);
                                    setTimeout(() => {
                                      handleGetSalesOrder();
                                    }, 1000);
                                  }}
                                >
                                  <img
                                    src={PagesIndex.Svg.reset}
                                    className="admin-icons"
                                    alt="Reset"
                                  />
                                </Index.Button>
                              </Index.Box>
                            </Index.Tooltip>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </form>
                )}
              </PagesIndex.Formik>
            </Index.Box>
          </Index.Box>
        </Index.Box>
        <Index.Box className="common-card">
          <Index.Box
            className={`admin-distric-table-main ${
              loading ? "" : "page-table-main"
            }`}
          >
            <Index.TableContainer
              component={Index.Paper}
              className="table-container"
            >
              {loading ? (
                <PagesIndex.Loader />
              ) : (
                <Index.Table aria-label="simple table" className="table">
                  <Index.TableHead className="table-head">
                    <Index.TableRow className="table-row">
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="10%"
                      >
                        Order Id
                      </Index.TableCell>

                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="15%"
                      >
                        Client Name
                      </Index.TableCell>

                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="15%"
                      >
                        Deal Name
                      </Index.TableCell>

                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="12%"
                      >
                        Total Amount
                      </Index.TableCell>
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="22%"
                      >
                        Created Date & Time
                      </Index.TableCell>

                      {/* <Index.TableCell
                            component="th"
                            variant="th"
                            className="table-th"
                            width="12%"
                          >
                            Status
                          </Index.TableCell> */}

                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="5%"
                        align="right"
                      >
                        Action
                      </Index.TableCell>
                    </Index.TableRow>
                  </Index.TableHead>
                  <Index.TableBody className="table-body">
                    {renderContent()}
                  </Index.TableBody>
                </Index.Table>
              )}
            </Index.TableContainer>
          </Index.Box>
          <Index.Box className="admin-pagination-main">
            {data?.totalCount?.count ? (
              <Index.Pagination
                page={currentPage}
                count={Math.ceil(data?.totalCount?.count / 10)}
                onChange={(event, newPage) => setCurrentPage(newPage)}
                variant="outlined"
                shape="rounded"
                className="admin-pagination"
              />
            ) : (
              ""
            )}
          </Index.Box>
        </Index.Box>
      </Index.Box>
      <PagesIndex.Formik
        enableReinitialize
        onSubmit={handleAddEditBlockResone}
        initialValues={initialValues}
        validationSchema={PagesIndex.userBlockedSchema}
        innerRef={formRef}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <>
            <Index.Modal
              open={openMessage}
              onClose={handleCloseMessage}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="admin-modal"
            >
              <form onSubmit={handleSubmit} noValidate="novalidate">
                <Index.Box
                  sx={style}
                  className="admin-add-user-modal-inner-main admin-modal-inner"
                >
                  <Index.Box className="admin-modal-header">
                    <Index.Typography
                      id="modal-modal-title"
                      className="admin-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      {" "}
                      Reason<span className="astrick-sing">*</span>{" "}
                      <span className="option-condition-text">
                        (Max character length: 500)
                      </span>
                    </Index.Typography>
                    <Index.Button
                      className="modal-close-btn"
                      onClick={handleCloseMessage}
                    >
                      <img
                        src={PagesIndex.Svg.closeblack}
                        className="admin-modal-close-icon"
                        alt="Close"
                      />
                    </Index.Button>
                  </Index.Box>
                  <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
                    <Index.Box className="admin-input-box admin-modal-input-box">
                      <Index.Box className="admin-form-group">
                        <Index.TextareaAutosize
                          aria-label="minimum height"
                          // minRows={3}
                          style={{ resize: "vertical", overflow: "auto" }}
                          placeholder="Example test"
                          className="admin-form-control-textarea"
                          name="reason"
                          onChange={handleChange}
                          value={values?.reason}
                          error={errors.reason && touched.reason}
                          maxLength={500}
                        />
                        <PagesIndex.FormHelperText className="admin-error-text">
                          {errors.reason && touched.reason
                            ? errors.reason
                            : null}
                        </PagesIndex.FormHelperText>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="modal-footer">
                    <Index.Box className="admin-modal-user-btn-flex">
                      <Index.Box className="admin-save-btn-main btn-main-primary">
                        <Index.Button
                          className="admin-icons-btn btn-primary update-btn"
                          type="Submit"
                          disabled={blockButtonSpinner}
                        >
                          {blockButtonSpinner ? (
                            <PagesIndex.Spinner />
                          ) : (
                            <>
                              <img
                                src={PagesIndex.Svg.blockicon}
                                className="admin-icons block-icon"
                                alt="Block"
                              ></img>
                              <span>Submit</span>
                            </>
                          )}
                        </Index.Button>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </form>
            </Index.Modal>

            <Index.Modal
              open={openDelete}
              onClose={handleCloseDelete}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="admin-modal"
            >
              <Index.Box
                sx={style}
                className="admin-delete-modal-inner-main admin-modal-inner"
              >
                <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
                  <Index.Box className="admin-modal-circle-main">
                    <img
                      src={PagesIndex.Svg.closecircle}
                      className="admin-user-circle-img"
                      alt="Close"
                    />
                  </Index.Box>
                  <Index.Typography
                    className="admin-delete-modal-title"
                    component="h2"
                    variant="h2"
                  >
                    Are you sure?
                  </Index.Typography>
                  <Index.Typography
                    className="admin-delete-modal-para admin-common-para"
                    component="p"
                    variant="p"
                  >
                    Do you really want to delete this sales deal? This process
                    cannot be undone.
                  </Index.Typography>
                  <Index.Box className="admin-delete-modal-btn-flex border-btn-main btn-main">
                    <Index.Button
                      className="admin-modal-cancel-btn border-btn"
                      onClick={handleCloseDelete}
                      disabled={deleteButtonSpinner}
                    >
                      Cancel
                    </Index.Button>
                    <Index.Button
                      className="delete-user admin-modal-delete-btn btn"
                      onClick={handleDeleteSalesOrder}
                      disabled={deleteButtonSpinner}
                    >
                      {deleteButtonSpinner ? (
                        <PagesIndex.Spinner />
                      ) : (
                        <span>Delete</span>
                      )}
                    </Index.Button>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Modal>

            <Index.Modal
              open={openView}
              onClose={handleCloseView}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="admin-modal"
            >
              <form onSubmit={handleSubmit} noValidate="novalidate">
                <Index.Box
                  sx={style}
                  className="admin-view-sales-modal-inner-main admin-modal-inner"
                >
                  <Index.Box className="admin-modal-header">
                    <Index.Typography
                      id="modal-modal-title"
                      className="admin-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      {" "}
                      Deal Details{" "}
                      <span className="sales-order-id-text">
                        ({modalData?.orderNo})
                      </span>
                    </Index.Typography>
                    <Index.Button
                      className="modal-close-btn"
                      onClick={handleCloseView}
                    >
                      <img
                        src={PagesIndex.Svg.closeblack}
                        className="admin-modal-close-icon"
                        alt="Close"
                      />
                    </Index.Button>
                  </Index.Box>
                  <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
                    <Index.Box className="sales-order-view-main">
                      <Index.Box className="sales-order-view-flex">
                        <Index.Box className="sales-order-view-left">
                          <Index.Box className="sales-order-view-content">
                            <Index.Typography className="sales-order-name-lable">
                              Client Name:
                            </Index.Typography>
                            <Index.Typography className="sales-order-name-text">
                              {modalData?.client?.firstName}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box>
                        <Index.Box className="sales-order-view-right">
                          <Index.Box className="sales-order-view-content">
                            <Index.Typography className="sales-order-name-lable">
                              Start Date:
                            </Index.Typography>
                            <Index.Typography className="sales-order-name-text">
                              {PagesIndex.moment(modalData?.startDate).format(
                                "DD/MM/YYYY"
                              )}
                            </Index.Typography>
                          </Index.Box>
                          <Index.Box className="sales-order-view-content">
                            <Index.Typography className="sales-order-name-lable">
                              End Date:
                            </Index.Typography>
                            <Index.Typography className="sales-order-name-text">
                              {PagesIndex.moment(modalData?.endDate).format(
                                "DD/MM/YYYY"
                              )}
                            </Index.Typography>
                          </Index.Box>

                          <Index.Box className="sales-order-view-content">
                            <Index.Typography className="sales-order-name-lable">
                              Status:
                            </Index.Typography>
                            <Index.Typography className="sales-order-name-text">
                              {modalData?.status}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                      <Index.Box className="common-card">
                        <Index.Box
                          className={`admin-order-details-table-main page-table-main`}
                        >
                          <Index.TableContainer
                            component={Index.Paper}
                            className="table-container"
                          >
                            {loading ? (
                              <PagesIndex.Loader />
                            ) : (
                              <Index.Table
                                aria-label="simple table"
                                className="table"
                              >
                                <Index.TableHead className="table-head">
                                  <Index.TableRow className="table-row">
                                    <Index.TableCell
                                      component="th"
                                      variant="th"
                                      className="table-th"
                                      width="2%"
                                    >
                                      Sr. No.
                                    </Index.TableCell>

                                    <Index.TableCell
                                      component="th"
                                      variant="th"
                                      className="table-th"
                                      width="5%"
                                    >
                                      Platform
                                    </Index.TableCell>

                                    <Index.TableCell
                                      component="th"
                                      variant="th"
                                      className="table-th"
                                      width="5%"
                                    >
                                      Element
                                    </Index.TableCell>

                                    <Index.TableCell
                                      component="th"
                                      variant="th"
                                      className="table-th"
                                      width="5%"
                                    >
                                      Total Units
                                    </Index.TableCell>
                                    {/* <Index.TableCell
                                    component="th"
                                    variant="th"
                                    className="table-th"
                                    width="5%"
                                  >
                                    Remaining Units
                                  </Index.TableCell> */}
                                    <Index.TableCell
                                      component="th"
                                      variant="th"
                                      className="table-th"
                                      width="5%"
                                    >
                                      Rate
                                    </Index.TableCell>
                                    <Index.TableCell
                                      component="th"
                                      variant="th"
                                      className="table-th"
                                      width="5%"
                                    >
                                      Selling Rate
                                    </Index.TableCell>

                                    <Index.TableCell
                                      component="th"
                                      variant="th"
                                      className="table-th"
                                      width="5%"
                                    >
                                      Amount
                                    </Index.TableCell>
                                  </Index.TableRow>
                                </Index.TableHead>
                                <Index.TableBody className="table-body">
                                  {modalData?.orderDetails?.map(
                                    (ele, index) => {
                                      return (
                                        <Index.TableRow
                                          className="table-row"
                                          key={ele?._id}
                                        >
                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            className="table-td"
                                          >
                                            {index + 1}
                                          </Index.TableCell>

                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            className="table-td"
                                          >
                                            {ele?.platform}
                                          </Index.TableCell>

                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            className="table-td"
                                          >
                                            {ele?.elements}
                                          </Index.TableCell>

                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            className="table-td"
                                          >
                                            {ele?.totalSeconds}
                                          </Index.TableCell>
                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            className="table-td"
                                          >
                                            <Index.Typography className="admin-table-data-text">
                                              {ele?.remainingUnits || "-"}
                                            </Index.Typography>
                                          </Index.TableCell>
                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            className="table-td"
                                          >
                                            {parseFloat(
                                              ele?.rate
                                            )?.toLocaleString("en-Us")}
                                          </Index.TableCell>
                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            className="table-td"
                                          >
                                            {ele?.discountrate}
                                          </Index.TableCell>

                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            className="table-td"
                                          >
                                            {parseFloat(
                                              ele?.amount
                                            )?.toLocaleString("en-Us")}
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      );
                                    }
                                  )}

                                  <Index.TableRow>
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    ></Index.TableCell>
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    ></Index.TableCell>
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    ></Index.TableCell>
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    ></Index.TableCell>
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    ></Index.TableCell>
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    ></Index.TableCell>
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                      align="right"
                                    >
                                      <Index.Box className="total-text">
                                        Total Amount:
                                      </Index.Box>
                                    </Index.TableCell>
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    >
                                      {parseFloat(
                                        modalData?.totalAmount
                                      )?.toLocaleString("en-Us")}
                                    </Index.TableCell>
                                  </Index.TableRow>
                                </Index.TableBody>
                              </Index.Table>
                            )}
                          </Index.TableContainer>
                        </Index.Box>
                      </Index.Box>
                      {modalData?.document?.length !== 0 && (
                        <>
                          <Index.Box className="view-sales-approve-box">
                            <Index.Box className="view-sales-approve-flex">
                              <Index.Box className="admin-sub-title-main">
                                <Index.Typography
                                  className="admin-sub-title"
                                  component="h2"
                                  variant="h2"
                                >
                                  List of Attachment
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="common-card attechment-card">
                            {modalData?.document?.map((url) => {
                              return (
                                // <Index.Box
                                //   className="sales-attechment-flex-box"
                                //   key={ele?._id}
                                // >
                                //   <Index.Box className="sales-attechment-box">
                                //     <Index.Typography className="sales-approve-attechment-name">
                                //       {ele?.file}
                                //     </Index.Typography>
                                //   </Index.Box>
                                // </Index.Box>

                                <Index.Box
                                  className="document-data-flex"
                                  key={url?.file}
                                >
                                  <Index.Box className="document-lable-flex">
                                    <Index.Typography className="document-id-text">
                                      {url?.name?.toUpperCase()}
                                    </Index.Typography>
                                    <Index.Typography className="document-lable-text">
                                      {url?.file}
                                    </Index.Typography>
                                  </Index.Box>
                                  <Index.Box className="document-content-main">
                                    <Index.Box className="document-delete-main">
                                      <Index.Button
                                        className="admin-table-data-btn"
                                        onClick={() => handleDownloadVideo(url)}
                                      >
                                        <img
                                          src={PagesIndex.Svg.download}
                                          className="admin-icon"
                                          alt="Download"
                                        ></img>
                                      </Index.Button>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              );
                            })}
                          </Index.Box>
                        </>
                      )}
                      {prevBookingsData?.length ? (
                        <>
                          <Index.Box className="other-flex">
                            <Index.Box className="admin-sub-title-main">
                              <Index.Typography
                                className="admin-sub-title"
                                component="h2"
                                variant="h2"
                              >
                                Booking Details
                              </Index.Typography>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="common-card">
                            <Index.Box
                              className={`admin-previous-order-details-table-main page-table-main`}
                            >
                              <Index.TableContainer
                                component={Index.Paper}
                                className="table-container"
                              >
                                {loading ? (
                                  <PagesIndex.Loader />
                                ) : (
                                  prevBookingsData?.map((dataOuter, index) => {
                                    return (
                                      <>
                                        <Index.Box className="name-highlight-box-flex">
                                          <Index.Box className="name-highlight-box">
                                            <Index.Typography className="name-highlight-text">
                                              {dataOuter?.name} -{" "}
                                              <span className="name-highlight-id-text">
                                                {dataOuter?.subOrderNo}
                                              </span>
                                            </Index.Typography>
                                          </Index.Box>
                                          <Index.Box className="date-box-flex">
                                            <Index.Typography className="date-text">
                                              Start Date:
                                              <span className="date-text-span">
                                                {PagesIndex.moment(
                                                  dataOuter?.startDate
                                                ).format("DD/MM/YYYY")}
                                              </span>
                                            </Index.Typography>
                                            <Index.Typography className="date-text">
                                              End Date:
                                              <span className="date-text-span">
                                                {PagesIndex.moment(
                                                  dataOuter?.endDate
                                                ).format("DD/MM/YYYY")}
                                              </span>
                                            </Index.Typography>
                                            <Index.Typography className="date-text">
                                              Created Date & Time:
                                              <span className="date-text-span">
                                                {PagesIndex.moment(
                                                  dataOuter?.createdAt
                                                ).format(
                                                  "DD/MM/YYYY hh:mm:ss A"
                                                )}
                                              </span>
                                            </Index.Typography>
                                          </Index.Box>
                                        </Index.Box>
                                        <Index.Table
                                          aria-label="simple table"
                                          className="table"
                                          key={dataOuter?._id}
                                        >
                                          <Index.TableHead className="table-head">
                                            <Index.TableRow className="table-row">
                                              <Index.TableCell
                                                component="th"
                                                variant="th"
                                                className="table-th"
                                                width="2%"
                                              >
                                                Sr. No.
                                              </Index.TableCell>

                                              <Index.TableCell
                                                component="th"
                                                variant="th"
                                                className="table-th"
                                                width="5%"
                                              >
                                                Platform
                                              </Index.TableCell>

                                              <Index.TableCell
                                                component="th"
                                                variant="th"
                                                className="table-th"
                                                width="5%"
                                              >
                                                Element
                                              </Index.TableCell>

                                              <Index.TableCell
                                                component="th"
                                                variant="th"
                                                className="table-th"
                                                width="5%"
                                              >
                                                Total
                                              </Index.TableCell>

                                              <Index.TableCell
                                                component="th"
                                                variant="th"
                                                className="table-th"
                                                width="5%"
                                              >
                                                Selling Rate
                                              </Index.TableCell>

                                              <Index.TableCell
                                                component="th"
                                                variant="th"
                                                className="table-th"
                                                width="5%"
                                              >
                                                Remaining Units
                                              </Index.TableCell>

                                              <Index.TableCell
                                                component="th"
                                                variant="th"
                                                className="table-th"
                                                width="5%"
                                              >
                                                Used Units
                                              </Index.TableCell>

                                              <Index.TableCell
                                                component="th"
                                                variant="th"
                                                className="table-th"
                                                width="5%"
                                              >
                                                Amount
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          </Index.TableHead>
                                          <Index.TableBody className="table-body">
                                            {dataOuter?.orderDetails?.map(
                                              (data, index) => {
                                                return (
                                                  <Index.TableRow
                                                    sx={{
                                                      "&:last-child td, &:last-child th":
                                                        {
                                                          border: 0,
                                                        },
                                                    }}
                                                    key={data?._id}
                                                  >
                                                    <Index.TableCell
                                                      component="td"
                                                      variant="td"
                                                      className="table-td"
                                                    >
                                                      <Index.Typography className="admin-table-data-text">
                                                        {index + 1}
                                                      </Index.Typography>
                                                    </Index.TableCell>

                                                    <Index.TableCell
                                                      component="td"
                                                      variant="td"
                                                      className="table-td"
                                                    >
                                                      <Index.Typography className="admin-table-data-text">
                                                        {data?.platform
                                                          ? data?.platform
                                                          : "-"}
                                                      </Index.Typography>
                                                    </Index.TableCell>

                                                    <Index.TableCell
                                                      component="td"
                                                      variant="td"
                                                      className="table-td"
                                                    >
                                                      <Index.Typography className="admin-table-data-text">
                                                        {data?.elements
                                                          ? data?.elements
                                                          : "-"}
                                                      </Index.Typography>
                                                    </Index.TableCell>

                                                    <Index.TableCell
                                                      component="td"
                                                      variant="td"
                                                      className="table-td"
                                                    >
                                                      <Index.Typography className="admin-table-data-text">
                                                        {data?.totalSeconds
                                                          ? data?.totalSeconds
                                                          : 0}{" "}
                                                        ({data?.unit})
                                                      </Index.Typography>
                                                    </Index.TableCell>

                                                    <Index.TableCell
                                                      component="td"
                                                      variant="td"
                                                      className="table-td"
                                                    >
                                                      <Index.Typography className="admin-table-data-text">
                                                        {" "}
                                                        {data?.discountrate
                                                          ? data?.discountrate
                                                          : 0}
                                                      </Index.Typography>
                                                    </Index.TableCell>

                                                    <Index.TableCell
                                                      component="td"
                                                      variant="td"
                                                      className="table-td"
                                                    >
                                                      <Index.Typography className="admin-table-data-text">
                                                        {" "}
                                                        {parseFloat(
                                                          data?.remainingUnits ||
                                                            0
                                                        )}
                                                      </Index.Typography>
                                                    </Index.TableCell>
                                                    <Index.TableCell
                                                      component="td"
                                                      variant="td"
                                                      className="table-td"
                                                    >
                                                      <Index.Typography className="admin-table-data-text">
                                                        {" "}
                                                        {parseFloat(
                                                          data?.units || 0
                                                        )}
                                                      </Index.Typography>
                                                    </Index.TableCell>

                                                    <Index.TableCell
                                                      component="td"
                                                      variant="td"
                                                      className="table-td"
                                                    >
                                                      <Index.Typography className="admin-table-data-text">
                                                        {parseFloat(
                                                          data?.unit ==
                                                            "seconds"
                                                            ? (data?.units *
                                                                data?.discountrate) /
                                                                10 || 0
                                                            : data?.units *
                                                                data?.discountrate ||
                                                                0
                                                        )?.toLocaleString(
                                                          "en-Us"
                                                        )}
                                                      </Index.Typography>
                                                    </Index.TableCell>
                                                  </Index.TableRow>
                                                );
                                              }
                                            )}
                                            <Index.TableRow>
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                className="table-td"
                                              ></Index.TableCell>
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                className="table-td"
                                              ></Index.TableCell>
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                className="table-td"
                                              ></Index.TableCell>
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                className="table-td"
                                              ></Index.TableCell>
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                className="table-td"
                                              ></Index.TableCell>
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                className="table-td"
                                              ></Index.TableCell>

                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                className="table-td"
                                                align="right"
                                              >
                                                <Index.Box className="total-text">
                                                  Total Amount:
                                                </Index.Box>
                                              </Index.TableCell>
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                className="table-td"
                                              >
                                                <Index.Box className="total-text">
                                                  {" "}
                                                  {parseFloat(
                                                    dataOuter?.totalAmount || 0
                                                  )?.toLocaleString("en-US")}
                                                </Index.Box>
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          </Index.TableBody>
                                        </Index.Table>
                                      </>
                                    );
                                  })
                                )}
                              </Index.TableContainer>
                            </Index.Box>
                          </Index.Box>
                        </>
                      ) : (
                        ""
                      )}
                    </Index.Box>
                  </Index.Box>

                  {/* <Index.Box className="sales-order-view-flex">
                  <Index.Box className="sales-order-view-content">
                    <Index.Typography className="sales-order-name-lable">
                      Request For Approvel:
                    </Index.Typography>
                    <Index.Typography className="sales-order-name-text">
                      {modalData?.approvalId?.name}
                    </Index.Typography>
                  </Index.Box>
                </Index.Box> */}

                  {adminDetails?._id == modalData?.approvalId?._id &&
                  modalData?.status !== "Reject" ? (
                    <>
                      <Index.Box className="admin-input-box add-user-input view-sales-approve-box">
                        <Index.FormHelperText className="admin-form-lable">
                          Reasons
                        </Index.FormHelperText>
                        <Index.Box className="admin-form-group">
                          <Index.TextareaAutosize
                            aria-label="minimum height"
                            // minRows={3}
                            placeholder=""
                            className="admin-form-control-textarea"
                            name="reason"
                            onChange={handleChange}
                            value={values?.reason}
                            error={errors.reason && touched.reason}
                            maxLength={500}
                          />
                          <PagesIndex.FormHelperText className="admin-error-text">
                            {errors.reason && touched.reason
                              ? errors.reason
                              : null}
                          </PagesIndex.FormHelperText>
                        </Index.Box>
                      </Index.Box>

                      <Index.Box className="admin-delete-modal-btn-flex border-btn-main btn-main sales-view-btn-flex">
                        <Index.Button
                          className="admin-modal-delete-btn btn"
                          onClick={() => setSelectedValue("Approve")}
                        >
                          Approve
                        </Index.Button>
                        <Index.Button
                          className="admin-modal-cancel-btn border-btn"
                          type="submit"
                        >
                          Reject
                        </Index.Button>
                      </Index.Box>
                    </>
                  ) : (
                    modalData?.reason && (
                      <Index.Box className="sales-order-view-flex">
                        <Index.Box className="sales-order-view-content">
                          <Index.Typography className="sales-order-name-lable">
                            Reason:
                          </Index.Typography>
                          <Index.Typography className="sales-order-name-text">
                            {modalData?.reason}
                          </Index.Typography>
                        </Index.Box>
                      </Index.Box>
                    )
                  )}
                </Index.Box>
              </form>
            </Index.Modal>
            <Index.Modal
              open={openLogModal}
              onClose={handleCloseLogModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="admin-modal"
            >
              <Index.Box
                sx={style}
                className="admin-log-modal-inner-main admin-modal-inner"
              >
                <Index.Box className="admin-modal-header">
                  <Index.Typography
                    id="modal-modal-title"
                    className="admin-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    {" "}
                    Activity Log
                  </Index.Typography>
                  <Index.Button
                    className="modal-close-btn"
                    onClick={handleCloseLogModal}
                  >
                    <img
                      src={PagesIndex.Svg.closeblack}
                      className="admin-modal-close-icon"
                      alt="Close"
                    />
                  </Index.Button>
                </Index.Box>
                <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
                  <Index.Box className="common-card">
                    <Index.Box className="page-table-main category-activity-table-main">
                      <Index.TableContainer
                        component={Index.Paper}
                        className="table-container"
                      >
                        {activityLoading ? (
                          <PagesIndex.Loader />
                        ) : (
                          <Index.Table
                            aria-label="simple table"
                            className="table"
                          >
                            <Index.TableHead className="table-head">
                              <Index.TableRow className="table-row">
                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="70%"
                                >
                                  Activity
                                </Index.TableCell>

                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="30%"
                                >
                                  Updated By
                                </Index.TableCell>
                              </Index.TableRow>
                            </Index.TableHead>
                            <Index.TableBody className="table-body">
                              {renderActivityLogContent()}
                            </Index.TableBody>
                          </Index.Table>
                        )}
                      </Index.TableContainer>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Modal>
          </>
        )}
      </PagesIndex.Formik>
    </>
  );
}
